import { z } from 'zod'

const ItemSchema = z.object({
  id: z.number(),
  name: z.string(),
})

const CategorySchema = z.object({
  id: z.number(),
  name: z.string(),
})

const ProviderSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  accepting_new_clients: z.number().nullable().optional(),
})

const ProviderApplicationSchema = z.object({
  provider_id: z.number(),
  global_business_category_id: z.number().nullable(),
  business_category_name: z.string(),
  accepting_new_clients: z.number().nullable().optional()
})

export const MarketplaceItemSchema = z.object({
  id: z.number(),
  provider_id: z.number(),
  program_id: z.number(),
  program_item_id: z.number(),
  global_item_category_id: z.number().nullable(),
  global_item_id: z.number(),
  status: z.number(),
  justification: z.string().nullable(),
  marketplace: z.string(),
  name: z.string(),
  type: z.string(),
  price: z.number(),
  comments: z.string().nullable(),
  keyword_tags: z.string().nullable(),
  image: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  status_name: z.string(),
  item: ItemSchema,
  category: CategorySchema,
  provider: ProviderSchema,
  provider_application: ProviderApplicationSchema.optional().nullable(),
})

export const MarketplaceItemListSchema = z.object({
  current_page: z.number(),
  data: z.array(MarketplaceItemSchema),
  first_page_url: z.string(),
  from: z.number().nullable(),
  last_page: z.number(),
  last_page_url: z.string(),
  links: z.array(z.object({
    url: z.string().nullable(),
    label: z.string(),
    active: z.boolean()
  })),
  next_page_url: z.string().nullable(),
  path: z.string(),
  per_page: z.union([z.string(), z.number()]),
  prev_page_url: z.string().nullable(),
  to: z.number().nullable(),
  total: z.number(),
})

export type MarketplaceItem = z.infer<typeof MarketplaceItemSchema>
export type MarketplaceItemList = z.infer<typeof MarketplaceItemListSchema>
